import { configPromise } from "../../config/configMiddleware";
import { getWith, postWith, deleteWith } from "../axios";

export async function getAllConsultantsWithRegions(regions: any[]): Promise<any> {
  try {
      const config = await configPromise;
    const url = `${config.REACT_APP_API_URL}v1/user/fetch-consultants?regions=[${regions}]`;
    return (await getWith<any[]>(url)) as any;
  } catch (ex: any) {
    throw ex.response.data;
  }
}

export async function getAllConsultants(): Promise<any> {
  try {
    const config = await configPromise;
    const url = `${config.REACT_APP_API_URL}v1/user/fetch-consultants`;
    return (await getWith<any[]>(url)) as any;
  } catch (ex: any) {
    throw ex.response.data;
  }
}

export async function assignConsultant(data: any) {
  try {
    const config = await configPromise;
    const url = `${config.REACT_APP_API_URL}v2/partnerV2/assign-consultant`;
    return (await postWith<any, any>(url, data)) as any;
  } catch (ex: any) {
    throw ex.response.data;
  }
}

export async function removeConsultant(data: any) {
  try {
    const config = await configPromise;
    const url = `${config.REACT_APP_API_URL}v2/partnerV2/remove-consultant`;
    return (await deleteWith<any, any>(url, data)) as any;
  } catch (ex: any) {
    throw ex.response.data;
  }
}


